module.exports = __webpack_public_path__ + "static/media/book-of-kingdoms.c5ff75dc.gif";